//
// Module for the split account index page
//
rs.module("participant/member/splitaccount/index",

    ["common/select-helper", "common/visibility", "controls/components/event-banner"],

    function (selectHelper, visibility, eventBanner) {

        function initialize(jsSelectors, percentageCodeValue, serviceCreditGrid, accountBalanceGrid) {
            var splitAccountForm = $.js(jsSelectors.splitAccountForm);
            var method = splitAccountForm.js(jsSelectors.method);
            var methodSelectHelper = selectHelper.getHelper(method);
            var percent = splitAccountForm.js(jsSelectors.percent);
            var fromDate = splitAccountForm.js(jsSelectors.fromDate);
            var toDate = splitAccountForm.js(jsSelectors.toDate);
            var methodHidden = splitAccountForm.js(jsSelectors.methodHidden);
            var percentHidden = splitAccountForm.js(jsSelectors.percentHidden);
            var fromDateHidden = splitAccountForm.js(jsSelectors.fromDateHidden);
            var toDateHidden = splitAccountForm.js(jsSelectors.toDateHidden);

            var gridsContainer = splitAccountForm.js(jsSelectors.gridsContainer);
            var submitButton = splitAccountForm.js(jsSelectors.submitButton);
            var backButton = splitAccountForm.js(jsSelectors.backButton);
            var saveButton = splitAccountForm.js(jsSelectors.saveButton);
            var hideGridsButton = splitAccountForm.js(jsSelectors.hideGridsButton);

            method.change(function () {
                percent.prop("disabled", method.val() != percentageCodeValue);
                if (method.val() != percentageCodeValue) {
                    percent.val(null);
                }
            });

            hideGridsButton.on("click", function () {
                serviceCreditGrid.rejectChanges();
                accountBalanceGrid.rejectChanges();
                eventBanner.removeErrorMessages();
                methodSelectHelper.setDisabled(false);
                percent.prop("disabled", method.val() != percentageCodeValue);
                fromDate.prop("disabled", false);
                toDate.prop("disabled", false);

                methodHidden.prop("disabled", true);
                percentHidden.prop("disabled", method.val() == percentageCodeValue);
                fromDateHidden.prop("disabled", true);
                toDateHidden.prop("disabled", true);

                visibility.show(submitButton);
                visibility.show(backButton);

                visibility.hide(gridsContainer);
                visibility.hide(saveButton);
                visibility.hide(hideGridsButton);
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);